/**
 * A marketplace's mark: a coloured disc with its monogram, in the platform's
 * own brand colour. Replaces the empty grey square that used to sit next to
 * every listing row. Drawn in CSS, so there are no logo files to fetch and no
 * trademark artwork checked into the repo; drop SVGs into
 * `web/public/platforms/<platform>.svg` and set `useLogos` to prefer them.
 */
const MARKS: Record<string, { text: string; bg: string; fg?: string }> = {
  ebay:     { text: "eb", bg: "#e53238" },
  poshmark: { text: "P",  bg: "#7f0353" },
  mercari:  { text: "m",  bg: "#ff0211" },
  depop:    { text: "d",  bg: "#ff2300" },
  vinted:   { text: "v",  bg: "#09b1ba" },
  facebook: { text: "f",  bg: "#1877f2" },
  etsy:     { text: "E",  bg: "#f1641e" },
  grailed:  { text: "G",  bg: "#000000" },
  local:    { text: "L",  bg: "#5f9e77" },
};

const useLogos = false;

export function PlatformMark({ platform, size = 36 }: { platform: string; size?: number }) {
  const m = MARKS[platform] ?? { text: platform.slice(0, 1).toUpperCase(), bg: "var(--ink-soft)" };
  const style: React.CSSProperties = {
    width: size,
    height: size,
    background: m.bg,
    color: m.fg ?? "#fff",
    fontSize: Math.round(size * 0.42),
  };
  return (
    <span className="platform-mark" style={style} title={platform} aria-label={platform} role="img">
      {useLogos ? (
        <img src={`/platforms/${platform}.svg`} alt="" onError={(e) => {
          (e.currentTarget.parentElement as HTMLElement).textContent = m.text;
        }} />
      ) : m.text}
    </span>
  );
}
